<template>
  <div>
    <EsHeaderView />
    <div class="container-box">
      <div class="app-container">
        <div class="page-header">
          <div class="page-title">{{ $t('message.home.pointMall') }}</div>
          <div class="my-point">
            <span>{{ $t('message.home.myPoints') }}: </span>
            <span class="point-num">{{ myPoint }}</span>
          </div>
        </div>

        <div class="filter-bar">
          <el-input v-model="keyword" :placeholder="$t('message.home.searchGoods')" prefix-icon="el-icon-search"
            style="width:280px" @keyup.enter.native="handleSearch" clearable @clear="handleSearch" />
        </div>

        <div v-loading="loading">
          <div class="goods-grid" v-if="list.length">
            <div class="goods-card" v-for="item in list" :key="item.goods && item.goods.id" @click="goDetail(item)">
              <img :src="item.goods && item.goods.thumbnail" class="goods-img" alt="" />
              <div class="goods-name">{{ item.goods && item.goods.name }}</div>
              <div class="goods-point">{{ item.exchangePoint }} {{ $t('message.home.points') }}</div>
            </div>
          </div>
          <el-empty v-if="!list.length && !loading" :description="$t('message.home.noData')" />
          <div class="common-pagination" v-if="total > 0">
            <el-pagination background layout="prev,pager,next,total" :page-size="queryParams.pageSize"
              :current-page="queryParams.pageNumber" :total="total" @current-change="currentChange" />
          </div>
        </div>
      </div>
    </div>
    <EsFooterView />
  </div>
</template>

<script>
import { exchange_list } from "@/api/goods/goods";
import { load_member } from "@/api/upms/profile";
import { isShopLoggedIn } from "@/util/shopAuth";

export default {
  name: "PointMall",
  data() {
    return { loading: false, list: [], total: 0, myPoint: 0, keyword: '',
      queryParams: { pageNumber: 1, pageSize: 20, keyword: '' } }
  },
  created() {
    this.loadData()
    this.loadPoint()
  },
  methods: {
    loadData() {
      this.loading = true
      const params = { pageNumber: this.queryParams.pageNumber, pageSize: this.queryParams.pageSize }
      if (this.keyword) params.keyword = this.keyword
      exchange_list(params).then(r => {
        const data = r.data?.data
        this.list = Array.isArray(data) ? data : (data?.content || [])
        this.total = Array.isArray(data) ? data.length : (data?.total || 0)
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    loadPoint() {
      if (!isShopLoggedIn(this)) {
        this.myPoint = 0
        return
      }
      load_member().then(r => { this.myPoint = r.data?.data?.member?.point ?? 0 }).catch(() => {})
    },
    handleSearch() { this.queryParams.pageNumber = 1; this.loadData() },
    currentChange(page) { this.queryParams.pageNumber = page; this.loadData() },
    goDetail(item) {
      this.$router.push({ path: '/point/goods/' + (item.goods && item.goods.id), query: { exchangePoint: item.exchangePoint } })
    },
  }
}
</script>

<style lang="scss" scoped>
.container-box { background: #f5f5f5; min-height: calc(100vh - 120px); }
.app-container { width: 1200px; margin: 0 auto; padding: 30px 0; }
.page-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; }
.page-title { font-size: 22px; font-weight: bold; }
.my-point { font-size: 15px; color: #606266; }
.point-num { font-size: 20px; font-weight: bold; color: #e6a23c; margin-left: 4px; }
.filter-bar { margin-bottom: 20px; }
.goods-grid { display: flex; flex-wrap: wrap; gap: 16px; }
.goods-card { background: #fff; border-radius: 8px; width: 220px; cursor: pointer; overflow: hidden; transition: box-shadow .2s; }
.goods-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,.12); }
.goods-img { width: 100%; height: 180px; object-fit: contain; display: block; background: #f7f7f7; }
.goods-name { padding: 10px 12px 4px; font-size: 14px; color: #303133; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.goods-point { padding: 4px 12px 12px; font-size: 16px; font-weight: bold; color: #e6a23c; }
.common-pagination { margin-top: 24px; text-align: center; }
</style>
